/**
 * @Author: Lihao sun sunlihao.cosmo@haier.com
 * @Date: 2024-12-17 09:57:15
 * @LastEditors: Lihao sun sunlihao.cosmo@haier.com
 * @LastEditTime: 2024-12-23 10:51:47
 * @FilePath: src/utils/request.js
 * @Description: 这是默认设置,可以在设置》工具》File Description中进行配置
 */
import axios from 'axios'
import { Message } from 'element-ui'
import store from '@/store'
import { getToken } from '@/utils/auth'
const controller = new AbortController()
// let isRefreshing = false
export const abortAllRequests = () => {
  controller.abort()
}

const service = axios.create({
  signal: controller.signal,
  timeout: 50000,
  withCredentials: false
})

// 处理错误信息
const handleError = (res) => {
  if (res.code === 401 || res.code === '401') {
    // if (!isRefreshing) {
    //   isRefreshing = true
    //   store.dispatch('user/resetToken').then(() => {
    //     abortAllRequests() // 终止所有请求
    //     window.location.reload()
    //   })
    // }
  } else {
    console.log(res, 'error-res')
    if (res.code == 10000) {
      Message({
        message: res.message || res.error || 'Error',
        type: 'error',
        duration: 2000,
        showClose: true
      })
    }
  }
}
service.interceptors.request.use(
  (config) => {
    // tianshu-api 接口不需要传 token
    // if (config.url && config.url.startsWith('/tianshu-api')) {
    //   return config
    // }

    if (store.getters.token) {
      const _token = getToken()
      config.headers['Authorization'] = `Bearer ${_token}`
      config.headers['Access-Token'] = _token
    }
    return config
  },
  (error) => {
    return Promise.reject(error)
  }
)
service.interceptors.response.use(
  (response) => {
    const res = response.data
    const isCfoApi = response.config.url && response.config.url.includes('/cfo-api/')
    if (
      res.code === 200 ||
      res.code === '200' ||
      res.code === 0 ||
      Array.isArray(res) ||
      res.status_code === 200 ||
      (isCfoApi && res && typeof res === 'object' && res.code === undefined)
    ) {
      return res
    } else if (res && res instanceof Blob) {
      // console.log('response', res)
      return res
    } else {
      if (
        (res.code === 401 || res.code === '401') &&
        response.config.url.includes('refreshToken')
      ) {
        Message({
          message: '登录已过期，请重新登录',
          type: 'warning',
          duration: 2000
        })
        store.dispatch('user/login')
        return
      } else {
        handleError(res)
        return Promise.reject(res)
      }
    }
  },
  (error) => {
    console.log(error, 'error')
    // 如果错误有响应值
    if (error.response && error.response.data) {
      handleError(error.response.data)
    } else if (
      error.code === 'ECONNABORTED' ||
      error.message === 'Network Error' ||
      error.message.includes('timeout')
    ) {
      // 网络超时异常处理
      // Message({
      //   message: '请求超时，请稍后重试',
      //   type: 'error',
      //   duration: 2 * 1000
      // })
    } else {
      Message({
        message: error.message,
        type: 'error',
        duration: 2000,
        showClose: true
      })
    }
    if (error.code === 'ECONNABORTED') {
      return Promise.reject('cancel')
    } else {
      return Promise.reject(error)
    }
  }
)
export const FileService = axios.create({
  // url = base url + request url
  // withCredentials: true, // send cookies when cross-domain requests
  timeout: 10000 // request timeout
})
FileService.interceptors.request.use(
  (config) => {
    config.responseType = 'arraybuffer'
    // if (store.getters.token) {
    config.headers['Authorization'] = 'Bearer ' + getToken()
    delete config.headers.Cookie
    // }
    return config
  },
  (error) => {
    // do something with request error
    return Promise.reject(error)
  }
)
export default service
